var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "eaChartsRef01", staticStyle: { height: "300px" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }